export default "$$material";
